/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserCreate { 
    RoleId: string;
    Name: string;
    Surname: string;
    Email: string;
    Password: string;
    CustomerId?: string | null;
}

